import { useEffect, useState } from 'react';

import { Card } from '@/components/common/Card/Card';
import { Badge } from '@/components/common/Badge/Badge';
import { classNames } from '@/utils/classNames';

import styles from '@/styles/common.module.css';

type LoadingStateProps = {
  title: string;
  messages: string[];
  className?: string;
  tone?: 'default' | 'soft';
};

export function LoadingState({
  title,
  messages,
  className,
  tone = 'soft',
}: LoadingStateProps): JSX.Element {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);

    if (messages.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % messages.length);
    }, 420);

    return () => window.clearInterval(intervalId);
  }, [messages]);

  return (
    <Card tone={tone} className={classNames(styles.loadingState, className)}>
      <div className={styles.loadingHeader}>
        <div className={styles.loadingSpinner} aria-hidden="true" />
        <div>
          <Badge tone="primary">Análise assistida por IA</Badge>
          <p className={styles.loadingTitle}>{title}</p>
        </div>
      </div>

      <ul className={styles.loadingMessages} aria-live="polite" aria-atomic="true">
        {messages.map((message, index) => (
          <li
            key={message}
            className={classNames(styles.loadingMessage, index === activeIndex && styles.loadingMessageActive)}
          >
            {message}
          </li>
        ))}
      </ul>
    </Card>
  );
}
